// extracted by mini-css-extract-plugin
export var messageSideLeft = "_jp-1";
export var messageSideRight = "_jp-2";
export var subscribeToBackInStockBubbleContainer = "_jp-0";